import { useQuery } from 'react-query';
import axiosInstance from './axiosInstance';
import logger from './server';
import { useAuthContext } from '../contexts/AuthContext';

const useFetch = (endpoint, id, data, enabled, method, baseUrl) => {
    const { user, tenant, checkToken } = useAuthContext();
    
    const fetchData = async () => {
        try {
            await checkToken();
            const response = await axiosInstance(method, endpoint, data, 'application/json', baseUrl);
            return response.data;
        } catch (err) {
            console.log("Erro na api" + endpoint + "ao buscar dados:", err);
            return null;
        };
    };
    return useQuery([id], () => fetchData(), {
        refetchOnWindowFocus: false,
        // refetchInterval: interval
        enabled: enabled === false ? false : true,
        retry: false,  // Desabilita tentativas automáticas em caso de erro
        onError: (error) => {
            console.error("Erro na api" + endpoint + "ao buscar dados:", error);  // Log do erro
            logger.error("User: " + user?.Username + " Tenant: " + tenant + ", Error getting the data", error)
        }
    });
};

export default useFetch;